import { DashboardContextModel } from '../pages/dashboard/dashboard.models'
import { getToken } from '../auth/auth.service'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootStoreModel } from '../redux'
import { getAppConfigurationValue } from '../redux'
import { AppConfigurationKey } from '../model/enums/appConfigurationKey'
import { envConfig } from '../config/envConfig'

export interface QlikContext {
  isContextInitialized: boolean
  context: DashboardContextModel | undefined
}

export const useQlikContext = (): QlikContext => {
  const profile = useSelector((state: RootStoreModel) => state.profile)

  const [isContextInitialized, setIsContextInitialized] = useState<boolean>(false)
  const [context, setContext] = useState<DashboardContextModel | undefined>(undefined)

  useEffect(() => {
    getToken().then(token => {
      setContext({
        userName: profile.user?.name, // 'pre2.globaleris.com@gmail.com',
        subscription: envConfig.subscriptions.front, // '1c5bcc50530048a6b1badba996e3643e',
        securityToken: token, //'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyIsImtpZCI6Im5PbzNaRHJPRFhFSzFqS1doWHNsSFJfS1hFZyJ9.eyJhdWQiOiJodHRwczovL2dsb2JhbGVyaXMub25taWNyb3NvZnQuY29tL09EYXRhU2VydmljZSIsImlzcyI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0LzM2M2IyMjExLWY3ZmQtNDBlMy1hNGQyLWYyMjFmOTkxNjA1MC8iLCJpYXQiOjE2MjczMTU3NzQsIm5iZiI6MTYyNzMxNTc3NCwiZXhwIjoxNjI3MzE5Njc0LCJhaW8iOiJFMllBZ3VXNm43WThFSk9YVG4rdStaYlAvd01BIiwiYXBwaWQiOiIwMWY1ZTMxNy1kZDlmLTQ0ZjgtYjJlNS1mZjM1MzAwZjk1NWMiLCJhcHBpZGFjciI6IjEiLCJpZHAiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zNjNiMjIxMS1mN2ZkLTQwZTMtYTRkMi1mMjIxZjk5MTYwNTAvIiwib2lkIjoiOWU0ODE3OWUtZDAzZC00YmU1LTg1YTItYWRlZDk4Y2JkMjNhIiwicmgiOiIwLkFUQUFFU0k3TnYzMzQwQ2swdkloLVpGZ1VCZmo5UUdmM2ZoRXN1WF9OVEFQbFZ3d0FBQS4iLCJyb2xlcyI6WyJBbGwiXSwic3ViIjoiOWU0ODE3OWUtZDAzZC00YmU1LTg1YTItYWRlZDk4Y2JkMjNhIiwidGlkIjoiMzYzYjIyMTEtZjdmZC00MGUzLWE0ZDItZjIyMWY5OTE2MDUwIiwidXRpIjoicDFPRnc3VzZha2VIQWIyRllxOV9BQSIsInZlciI6IjEuMCJ9.e3fHzVo6D_8tDygvV1NYnCX7OhotcWn2Khvpgpq1ikI7JRZV-7lfVESNdKxg6FZHTYP3UlNcJKE8LK7SSsClHTy5WMVkOTZn4ADpnuvNybbSHGxlH8m7-58vbZBafDTj7M_Re3LVbNvskaNt0nEyR3KHwpoA4pSOQg7JBsllw32wOnPlkT5ayosGAwHVStkXWTOrnk-snGoQzeinF61o5oYhI7eRGJDRAtCKzO-a6exnA4zj1NxUsQCqY7c5Fx-DLtjaKuOl25r4Seyp6k3fLNGxq3hgx8xAYVBpXmIY_vglhajeUNbtUZiRftaecK5AgVZATtNqZAwSn8ppYRRxHg',
        roles: profile.user?.roles.map(item => item.description).join(), //'ViewAll,ViewAdminCisternas,ViewClienteCisternas,ViewInformes,ViewCompraVenta,ViewInventarioClientes,Administracion,ViewConfiguradorFacturas,ViewClientes,ViewTrades,ViewRemit,ViewBuques,ViewFacturaCliente,ViewPrevisisonLP,ViewBalanceGasinera,ViewCompraVentaBeta';
        client: profile.user?.domain, //'PRE2.GLOBALERIS.COM',
        conceptApiEndpoint: `${getAppConfigurationValue(
          AppConfigurationKey.Host
        )}${getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixConceptApi)}/api/`,
        reportsQlikApiEndpoint: `${getAppConfigurationValue(
          AppConfigurationKey.Host
        )}${getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixConceptQlik)}/api/`,
        invoicesListPath: '/Content/Angular/listadoFacturas/dist/',
        templateConfigPath: '/Content/Angular/configuradorPlantillas/dist/',
        widgetConfigPath: '/Content/Angular/configurador-widgets-app/dist/',
        dashboardConfigPath: '/Content/Angular/configuradorDashboard/dist/',
        qlikEnvironmentUrl: getAppConfigurationValue(AppConfigurationKey.WebHostQlik), // 'qlikserverdes.globaleris.com',
        qlikPrefix: '/qlik/',
        qlikPort: 443,
        qlikSecure: true,
        jQueryPath: '/Content/Angular/jQuery/jquery-3.1.1.js',
        bootstrapJsPath: '/Content/Angular/Bootstrap/bootstrap.js',
        bootstrapCssPath: '/Content/Angular/Bootstrap/bootstrap.css',
        fontAwesomeCssPath: '/Content/Angular/css/font-awesome.min.css'
      } as DashboardContextModel)

      setIsContextInitialized(true)
    })
  }, [])

  return { isContextInitialized, context }
}
